import React from "react";
import './loader.scss'

const LoaderLinear = ({isLoading}) => {
    return (
        <div className={isLoading ? "loader" : ''}>
            <div className="loader__bar"></div>
        </div>
    )
}

export default LoaderLinear